import {Component, Input, Output, OnChanges, OnInit, EventEmitter} from "@angular/core";
import {IComment} from "../subcategory/comments/comments.component";
import {IDocumentMetadata} from "../../tax-return/model/i-tax-return";
import { FileSystemService } from "../../../../../swaggerServices";
import { AttachmentRef } from "../urls";

@Component({
    selector: "app-comment",
    templateUrl: "./comment.component.html",
    styleUrls: ["./comment.component.scss"],
    standalone: false
})
export class CommentComponent implements OnInit, OnChanges {
  @Input() comment: IComment;
  @Input() documents: IDocumentMetadata[];
  @Output() imgClick = new EventEmitter<string>();
  srcMap: Record<string, string> = {};
  docsById: {[docId: string]: IDocumentMetadata};
  private normalizeAttachment(attachment: string | AttachmentRef): AttachmentRef {
    if (typeof attachment === "string") {
      const parts = attachment.split(/[\\/]/);
      const fileName = parts[parts.length - 1] || attachment;
      const extension = (fileName.split(".").pop() || "").toLowerCase();
      return {
        id: attachment,
        fileName,
        extension,
      };
    }
    return attachment;
  }

  getAttachmentName(attachment: string | AttachmentRef): string {
    const normalized = this.normalizeAttachment(attachment);
    return normalized.fileName || normalized.id;
  }

  getAttachmentId(attachment: string | AttachmentRef): string {
    return this.normalizeAttachment(attachment).id;
  }

  getImageTitle(imageId: string): string {
    const imagePart = this.comment?.parts?.find(part => part?.image === imageId);
    return imagePart?.imageName || imageId;
  }



  constructor(
    private fileSystemService: FileSystemService
  ) { }

  updateImageSource(parts: IComment["parts"]) {
    parts.filter(p => !!p.image).forEach(({image}) => {
      this.fileSystemService.fileSystemDownloadSingleFilePut({documentId: image}).subscribe(({fileContent, fileName}) => {
        const ext = fileName.split(".").pop();
        this.srcMap[image] = `data:image/${ext};base64,${fileContent}`;
      })
    })
  }

  ngOnInit() {
    this.updateImageSource(this.comment.parts);
  }

  ngOnChanges(changes) {
    if (changes.documents) {
      const docsById = {};
      this.documents.forEach(d => {
        docsById[d.id] = d;
      });
      this.docsById = docsById;
    }
    this.updateImageSource(changes?.comment?.currentValue?.parts ?? []);
  }

  getCommentParts(comment) {
    if (this.documents.length === 0) {
      const parts = comment.parts.map(p => {
        const text = p.text?.replace(/\\</gi, '<');
        return {...p, text}
      });
      return parts;
    }
    return comment.parts.map(p => {
      if (p.docId) {
        const doc = this.docsById[p.docId];
        return {...p, text: doc.filename};
      } else {
        return p;
      }
    });
  }

  downloadAttachment(attachment: string | AttachmentRef) {
    const attachmentId = this.getAttachmentId(attachment);
    this.fileSystemService.fileSystemDownloadSingleFilePut({ documentId: attachmentId }).subscribe(({ fileContent, fileName }) => {
      const elem = window.document.createElement('a');
      elem.href = `data:application/octet-stream;base64,${fileContent}`;
      elem.download = fileName;
      document.body.appendChild(elem);
      elem.click();
      document.body.removeChild(elem);
    })
  }

  commentPartsTrackBy(index: number, comment) {
    return `${comment.id}-${index}`;
  }

  onImageClick(src: string) {
    this.imgClick.emit(src);
  }
}
